module.exports = __webpack_public_path__ + "static/media/country_sb.f069059f.webp";